export default __webpack_public_path__ + "static/media/avatar_96.74a26ec8.png";